// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","hint":"hint_PAljG","exact":"exact_dw3SQ"};